var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-white page-categories-gemrcn",
      staticStyle: { "margin-top": "-15px" }
    },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalEditionCategorie",
            size: "lg",
            "hide-footer": "",
            "header-bg-variant": "gradient-bleu",
            "header-text-variant": "light"
          }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _c("h3", { staticStyle: { color: "white" } }, [
              _vm._v("Édition de catégorie GEMRCN")
            ])
          ]),
          _c(
            "template",
            { slot: "default" },
            [
              _c("EditionCategorieGEMRCN", {
                attrs: { categorie: _vm.currentCategorie },
                on: {
                  "categorie-enregistree": _vm.categorieEnregistree,
                  "annuler-edition": _vm.fermerModalCategorie
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm.profilIsAdmin
        ? _c(
            "div",
            {
              staticClass: "container-fluid bg-gradient-bleu",
              staticStyle: { "min-height": "60px", padding: "10px" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn",
                  staticStyle: {
                    "background-color": "white",
                    "font-weight": "bold",
                    "font-size": "12px"
                  },
                  on: { click: _vm.ajouterCategorie }
                },
                [_vm._v("Ajouter")]
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          key: _vm.key,
          staticClass: "container-fluid no-padding",
          staticStyle: { "min-height": "65vh", "background-color": "inherit" }
        },
        [
          _c("table", { staticClass: "table table-sm table-bordered" }, [
            _vm._m(0),
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.categories, function(categorie, iCategorie) {
                return _c(
                  "tr",
                  {
                    key: iCategorie,
                    staticStyle: { cursor: "pointer" },
                    attrs: { title: "Editer la catégorie" },
                    on: {
                      click: function($event) {
                        return _vm.editerCategorie(categorie)
                      }
                    }
                  },
                  [
                    _c("td", [
                      _c("div", {
                        style:
                          "height: 20px;width: 20px;margin: 0 auto;background-color:" +
                          categorie.couleur
                      })
                    ]),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      categorie.actif
                        ? _c("i", {
                            staticClass: "fas fa-check vertAgapInverse",
                            staticStyle: { margin: "0 auto" },
                            attrs: { title: "Catégorie active" }
                          })
                        : _vm.profilIsAdmin
                        ? _c("i", {
                            staticClass: "fas fa-trash rougeAgapInverse",
                            staticStyle: { margin: "0 auto" },
                            attrs: { title: "Supprimer la catégorie" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.supprimerCategorie(categorie)
                              }
                            }
                          })
                        : _c("i", {
                            staticClass: "fas fa-times rougeAgapInverse",
                            staticStyle: { margin: "0 auto" },
                            attrs: { title: "Catégorie inactive" }
                          })
                    ]),
                    _c("td", [
                      categorie.actif
                        ? _c("span", [_vm._v(_vm._s(categorie.nom))])
                        : _c("span", { staticStyle: { color: "gray" } }, [
                            _c("s", [_c("i", [_vm._v(_vm._s(categorie.nom))])])
                          ])
                    ]),
                    _c("td", [
                      categorie.couleur
                        ? _c("i", {
                            staticClass: "fas fa-trash rougeAgapInverse",
                            staticStyle: { margin: "0 auto" },
                            attrs: { title: "Supprimer la configuration" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.supprimerConfiguration(categorie)
                              }
                            }
                          })
                        : _vm._e()
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "60px" } }),
      _c("col", { staticStyle: { width: "40px" } }),
      _c("col"),
      _c("col", { staticStyle: { width: "40px", "text-align": "center" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("Actif")]),
        _c("th", [_vm._v("Nom")]),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }